// Common Sentry configuration shared between client and server
export const SENTRY_CONFIG = {
  environment: process.env.NODE_ENV || "development",
  release: process.env.REACT_APP_VERSION || "0.0.0",
  tracesSampleRate: 1.0,
  // Adjust this based on your needs (1.0 = 100% of transactions)
  debug: process.env.NODE_ENV !== "production"
};
